module.exports = __webpack_public_path__ + "static/media/playstore-6b.b61fc8a3.png";